import { Trash } from "lucide-react";
import React from "react";
import { DeletePacketButton } from "./DeletePacketButton";

type Props = React.ComponentProps<typeof DeletePacketButton>;

export const DeletePacketIconButton: React.FC<Props> = (props) => (
  <DeletePacketButton variant="danger" StartIcon={Trash} iconOnly {...props} />
);
